<template>
  <div class="main" @copy="handleCopy" @cut="handleCopy">
    <div v-if="dataUpdatedAt" class="data-updated">数据更新于 {{ dataUpdatedAt }} <br>
      使用wm昨日均价，仅供参考。可能会出现更新失败，或wm接口提供数据和显示数据不一致的情况</div>
    <div class="config">
      <label align="center">
        <input type="checkbox" v-model="showInGame" />游戏内名称
      </label>
      <label align="center">
        <input type="checkbox" v-model="leftIsGroup" />部件分组
      </label>
      <label align="center">
        <input type="checkbox" v-model="useLocalData" @change="onDataSourceChange" :disabled="isLoading" />使用历史数据（偶尔会漏几天数据）
        <select v-model="selectedDate" @change="loadSelectedData" class="date-select" :disabled="isLoading || !useLocalData">
          <option value="">{{ isLoading ? '加载中...' : '选择日期' }}</option>
          <option v-for="date in availableDates" :key="date" :value="date">{{ formatDate(date) }}</option>
        </select>
      </label>
      <label align="center">
        <input type="checkbox" v-model="showPercentile" @change="onPercentileToggle" :disabled="isLoading" />历史分位点（天）
        <select v-model="selectedPercentilePeriod" class="date-select">
          <option v-for="p in percentilePeriods" :key="p" :value="p">{{ p }}</option>
        </select>
      </label>
      <label align="center">
        <input type="checkbox" v-model="sortByPercentile" @change="onSortByPercentileChange" />按历史分位点排序
      </label>
    </div>
    <div class="container">

      <!-- 左侧分组 -->
      <div class="left-panel">
        <h2>部件</h2>
        <div class="controls">
          <label>
            <input type="checkbox" v-model="leftIncludeWarframe" />
            战甲部件
          </label>
          <label>
            <input type="checkbox" v-model="leftIncludeNonWarframe" />
            其他部件
          </label>
          <input type="text" v-model="searchQuery" placeholder="搜索物品名称" class="search-input" />
        </div>
        <!-- <div v-for="group in filteredPriceGroups" :key="group.title" class="group">
        <h3>{{ group.title }}</h3>
        <div class="item-grid">
          <div v-for="item in group.items" :key="item.id" class="item-row">
            <span class="name">{{ formatName(item.item_name) }}</span>
            <span class="price">{{ item.aver_price }}p</span>
          </div>
        </div>
      </div> -->
        <!-- 分组模式 -->
        <div v-if="leftIsGroup">
          <div v-for="group in filteredPriceGroups" :key="group.title" class="group">
            <h3>{{ group.title }}</h3>
            <div class="item-grid">
              <div v-for="item in group.items" :key="item.id" class="item-row"
                   :class="{'item-row-3col': showPercentile}"
                   :style="getPercentileStyle(item)">
                <span class="name">{{ formatName(item.item_name) }}</span>
                <span class="price">{{ item.aver_price }}p</span>
                <span v-if="showPercentile" class="percentile-col">{{ formatPercentile(getPercentileForItem(item)) }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 平铺模式 -->
        <div v-else>
          <div class="group">
            <div class="item-grid">
              <div v-for="item in flatItems" :key="item.id" class="item-row"
                   :class="{'item-row-3col': showPercentile}"
                   :style="getPercentileStyle(item)">
                <span class="name">{{ formatName(item.item_name) }}</span>
                <span class="price">{{ item.aver_price }}p</span>
                <span v-if="showPercentile" class="percentile-col">{{ formatPercentile(getPercentileForItem(item)) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 中间套装价格 -->
      <div class="middle-panel">
        <h2>套装</h2>
        <div class="controls">
          <label>
            <input type="checkbox" v-model="midIncludeWarframe" />
            战甲
          </label>
          <label>
            <input type="checkbox" v-model="midIncludeNonWarframe" />
            其他
          </label>
          <input type="text" v-model="setSearchQuery" placeholder="搜索物品名称" class="search-input" />
        </div>
        <div class="item-grid">
          <div v-for="item in filteredSetItems" :key="item.id" class="item-row"
               :class="{'item-row-3col': showPercentile}"
               :style="getPercentileStyle(item)">
            <span class="name">{{ formatName(item.item_name) }}</span>
            <span class="price">{{ item.aver_price }}p</span>
            <span v-if="showPercentile" class="percentile-col">{{ formatPercentile(getPercentileForItem(item)) }}</span>
          </div>
        </div>
      </div>

      <!-- 右侧收益分析 -->
      <div class="right-panel">
        <h2>核桃期望收益</h2>
        <div class="filter-controls">
          <div class="tabs">
            <button v-for="type in types" :key="type" :class="{ active: selectedType === type }"
              @click="selectedType = type">
              {{ relicTypeToName[type] }}
            </button>
          </div>
          <div class="quantity">
            <button v-for="num in quantities" :key="num" :class="{ active: selectedQuantity === num }"
              @click="selectedQuantity = num">
              {{ num }}人
            </button>
          </div>
          <div class="aya-filter">
            <label>
              <input type="checkbox" v-model="enableAya" />
              按重生筛选
            </label>
            <select v-model="selectedAyaPeriod" @change="onAyaPeriodChange" class="aya-select">
              <option v-for="period in ayaPeriods" :key="period.date" :value="period.date">
                {{ period.name }} ({{ period.date }})
              </option>
            </select>
          </div>
        </div>
        <input type="text" v-model="incomeSearchQuery" placeholder="搜索物品名称" class="search-input full-width" />

        <div class="income-list">
          <div v-for="item in filteredIncome" :key="item.id" class="item-row"
               :class="{'item-row-3col': showPercentile}"
               :style="getPercentileStyle(item)">
            <span class="name">{{ formatName(item.item_name) }}</span>
            <span class="income">
              {{ getIncomeValue(item, selectedType, selectedQuantity) }}p
            </span>
            <span v-if="showPercentile" class="percentile-col">{{ formatPercentile(getPercentileForItem(item)) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pinyin from 'js-pinyin';

export default {
  data() {
    return {
      items: [],
      dataUpdatedAt: '',

      showInGame: true,
      leftIsGroup: true,

      leftIncludeWarframe: true,
      leftIncludeNonWarframe: true,

      // 数据选择相关
      availableDates: [],
      dateToFilename: {}, // 日期到完整文件名的映射
      selectedDate: '',
      useLocalData: false,
      isLoading: false,

      // 历史分位点相关
      showPercentile: false,
      sortByPercentile: false,
      selectedPercentilePeriod: 'all',
      percentilePeriods: ['30', '90', '180', '360', 'all'],
      percentileData: {},

      midIncludeWarframe: true,
      midIncludeNonWarframe: true,

      includeSet: true,
      includeNonPrime: true,
      searchQuery: '',
      setSearchQuery: '',
      incomeSearchQuery: '',
      selectedType: 'radiant',
      selectedQuantity: 4,
      types: ['intact', 'flawless', 'radiant'],
      quantities: [1, 2, 4],
      relicTypeToName: {
        'intact': '完整',
        'flawless': '无暇',
        'radiant': '光辉',
      },
      item_pinyin: {},
      item_pinyin_first: {},
      enableAya: false,
      ayaPeriods: [],
      selectedAyaPeriod: '',
      currentAyaRelics: [],
    };
  },
  computed: {
    // 过滤后的价格分组
    filteredPriceGroups() {
      const queryStr = this.searchQuery;
      return this.priceGroups.map(group => ({
        ...group,
        items: group.items.filter(item =>
          0 < item.aver_price && // 只包含价格大于0的物品
          !item.item_name.includes('一套') &&
          (this.leftIncludeWarframe || !this.isWarframe(item.item_name)) &&
          (this.leftIncludeNonWarframe || this.isWarframe(item.item_name)) &&
          (item.item_name.toLowerCase().includes(queryStr.toLowerCase()) 
            || this.item_pinyin[item.item_name].includes(queryStr.toLowerCase())
            || this.item_pinyin_first[item.item_name].includes(queryStr.toLowerCase()))
          )
      }
      ));
    },
    // 将分组数据展平为单个数组
    flatItems() {
      const all = this.filteredPriceGroups.flatMap(group => group.items);
      if (this.sortByPercentile) {
        return [...all].sort((a, b) => (this.getPercentileForItem(b) ?? -1) - (this.getPercentileForItem(a) ?? -1) || b.aver_price - a.aver_price);
      }
      return all;
    },
    // 价格分组逻辑
    priceGroups() {
      const sortFn = this.sortByPercentile
        ? (a, b) => (this.getPercentileForItem(b) ?? -1) - (this.getPercentileForItem(a) ?? -1) || b.aver_price - a.aver_price
        : (a, b) => b.aver_price - a.aver_price;
      return [
        {
          title: '50+',
          items: this.items.filter(i => i.aver_price >= 50).sort(sortFn)
        },
        {
          title: '40+',
          items: this.items.filter(i => i.aver_price >= 40 && i.aver_price < 50).sort(sortFn)
        },
        {
          title: '30+',
          items: this.items.filter(i => i.aver_price >= 30 && i.aver_price < 40).sort(sortFn)
        },
        {
          title: '其他',
          items: this.items.filter(i => i.aver_price > 0 && i.aver_price < 30).sort(sortFn)
        }
      ];
    },
    // 过滤后的套装价格
    filteredSetItems() {
      const queryStr = this.setSearchQuery;
      return this.items
        .filter(item => item.item_name.includes('一套') &&
          0 < item.aver_price &&
          (this.midIncludeWarframe || !this.isWarframe(item.item_name)) &&
          (this.midIncludeNonWarframe || this.isWarframe(item.item_name)) &&
          (item.item_name.toLowerCase().includes(queryStr.toLowerCase()) 
            || this.item_pinyin[item.item_name].includes(queryStr.toLowerCase())
            || this.item_pinyin_first[item.item_name].includes(queryStr.toLowerCase())))
        .sort(this.sortByPercentile
          ? (a, b) => (this.getPercentileForItem(b) ?? -1) - (this.getPercentileForItem(a) ?? -1) || b.aver_price - a.aver_price
          : (a, b) => b.aver_price - a.aver_price);
    },
    // 过滤后的收益数据
    filteredIncome() {
      const queryStr = this.incomeSearchQuery;
      let filtered = this.sortedIncome.filter(item =>
        item.item_name.includes('遗物') &&
        !item.item_name.includes('安魂') &&
        (item.item_name.toLowerCase().includes(queryStr.toLowerCase()) 
          || this.item_pinyin[item.item_name].includes(queryStr.toLowerCase())
          || this.item_pinyin_first[item.item_name].includes(queryStr.toLowerCase()))
      );
      
      // 如果启用了当期阿耶，只显示 relics 中的物品
      if (this.enableAya && this.currentAyaRelics.length > 0) {
        filtered = filtered.filter(item => 
          this.currentAyaRelics.some(relic => item.item_name.includes(relic))
        );
      }
      
      return filtered;
    },
    // 收益排序数据
    sortedIncome() {
      return [...this.items].sort((a, b) => {
        const aVal = this.getIncomeValue(a, this.selectedType, this.selectedQuantity);
        const bVal = this.getIncomeValue(b, this.selectedType, this.selectedQuantity);
        return bVal - aVal;
      });
    }
  },
  methods: {
    generateItemKeywords() {
      for (const item of this.items) {
        this.item_pinyin[item.item_name] = this.getPinyinFull(item.item_name).toLowerCase().replace(/\s+/g, '');
        const fs =  this.getPinyinFirst(item.item_name).toLowerCase().replace(/\s+/g, '');
        this.item_pinyin_first[item.item_name] = fs;

        if (item.item_name.includes('遗物')) {
          this.item_pinyin_first[item.item_name] = fs + " " + fs.substring(0, 1) + fs.substring(2);
        }
      }
    },
    getPinyinFull(str) {
      if (!str) return '';
      return Array.from(str).map(char => {
        return /[\u4e00-\u9fa5]/.test(char)
          ? pinyin.getFullChars(char).toUpperCase()
          : char;
      }).join('');
    },
    getPinyinFirst(str) {
      if (!str) return '';
      return Array.from(str).map(char => {
        return /[\u4e00-\u9fa5]/.test(char)
          ? pinyin.getFullChars(char).charAt(0).toUpperCase()
          : char;
      }).join('');
    },
    async fetchData() {
      try {
        const response = await fetch('//wf.sariabell.com/data.json');
        const lastModified = response.headers.get('Last-Modified');
        if (lastModified) {
          const d = new Date(lastModified);
          this.dataUpdatedAt = `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`
            + `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
        }
        this.items = await response.json();

        this.items.forEach(item => {
          item['item_name'] = this.getNameCn(item);
        });

        this.generateItemKeywords();
      } catch (error) {
        console.error('数据加载失败:', error);
      }
    },
    async loadAvailableDates() {
      if (this.availableDates.length > 0) {
        return; // 已经加载过了，避免重复加载
      }
      
      // 方法1: 尝试获取 JSON 格式的文件列表
      try {
        const jsonResponse = await fetch('/filelist.json');
        if (jsonResponse.ok) {
          const fileList = await jsonResponse.json();
          if (Array.isArray(fileList)) {
            this.parseFileList(fileList);
            if (this.availableDates.length > 0 && !this.selectedDate) {
              this.selectedDate = this.availableDates[0];
            }
            return;
          }
        }
      } catch (e) {
        // JSON 文件不存在，继续尝试其他方式
      }
      
      // 方法2: 尝试从目录列表获取（HTML 或 JSON）
      try {
        const response = await fetch('/data/');
        if (!response.ok) {
          throw new Error('无法访问data目录');
        }
        
        const contentType = response.headers.get('content-type') || '';
        
        // 如果是 JSON 格式
        if (contentType.includes('application/json')) {
          const fileList = await response.json();
          if (Array.isArray(fileList)) {
            this.parseFileList(fileList);
          } else if (fileList.files && Array.isArray(fileList.files)) {
            this.parseFileList(fileList.files);
          }
        } else {
          // 解析 HTML 获取文件名
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const links = doc.querySelectorAll('a');
          
          const fileList = [];
          links.forEach(link => {
            const filename = link.textContent.trim();
            if (filename && !filename.endsWith('/') && filename !== '..') {
              fileList.push(filename);
            }
          });
          
          this.parseFileList(fileList);
        }
        
        if (this.availableDates.length === 0) {
          console.warn('在data目录中没有找到任何数据文件');
          // 尝试备用方案
          await this.tryCommonDates();
        } else if (!this.selectedDate) {
          this.selectedDate = this.availableDates[0]; // 默认选择最新日期
        }
      } catch (error) {
        console.error('获取可用日期失败:', error);
        // 备用方案：尝试一些常见的日期
        await this.tryCommonDates();
      }
    },
    parseFileList(fileList) {
      const dates = new Set();
      const dateToFilename = {};
      
      fileList.forEach(filename => {
        if (filename && filename.includes('items.simulate_income.json.')) {
          // 提取日期部分 (YYYYMMDD)
          const match = filename.match(/items\.simulate_income\.json\.(\d{8})_/);
          if (match) {
            const date = match[1];
            dates.add(date);
            // 保存该日期对应的完整文件名（如果有多个，保留最新的）
            if (!dateToFilename[date] || filename > dateToFilename[date]) {
              dateToFilename[date] = filename;
            }
          }
        }
      });
      
      this.availableDates = Array.from(dates).sort().reverse(); // 最新日期在前
      this.dateToFilename = dateToFilename;
    },
    async tryCommonDates() {
      const dates = [];
      const dateToFilename = {};
      const today = new Date();
      
      // 尝试最近30天的日期，每个日期尝试多个时间戳
      for (let i = 0; i < 30; i++) {
        const date = new Date(today);
        date.setDate(date.getDate() - i);
        const dateStr = date.toISOString().slice(0, 10).replace(/-/g, '');
        
        // 尝试多个时间戳（090000 到 090059，每秒一个）
        let found = false;
        for (let second = 0; second < 60 && !found; second++) {
          const timestamp = `090${String(second).padStart(2, '0')}`;
          const testFilename = `items.simulate_income.json.${dateStr}_${timestamp}`;
          
          try {
            // 使用 HEAD 请求只检查文件是否存在，不下载文件内容
            const response = await fetch(`/data/${testFilename}`, {
              method: 'HEAD'
            });
            if (response.ok) {
              dates.push(dateStr);
              dateToFilename[dateStr] = testFilename;
              found = true;
            }
          } catch (e) {
            // 忽略错误，继续尝试下一个时间戳
          }
        }
      }
      
      this.availableDates = dates;
      this.dateToFilename = { ...this.dateToFilename, ...dateToFilename };
      if (dates.length > 0) {
        this.selectedDate = dates[0];
      }
    },
    async loadSelectedData() {
      if (!this.selectedDate || this.isLoading) return;
      
      this.isLoading = true;
      try {
        // 使用保存的完整文件名，如果没有则尝试从目录列表获取
        let filename = this.dateToFilename[this.selectedDate];
        
        if (!filename) {
          // 如果映射中没有，尝试从目录列表获取
          await this.loadAvailableDates();
          filename = this.dateToFilename[this.selectedDate];
        }
        
        // 如果还是没有，尝试使用默认格式（向后兼容）
        if (!filename) {
          filename = `items.simulate_income.json.${this.selectedDate}_090001`;
        }
        
        const response = await fetch(`/data/${filename}`);
        
        if (!response.ok) {
          throw new Error(`文件不存在: ${filename}`);
        }
        
        const data = await response.json();
        this.items = data;
        
        this.items.forEach(item => {
          item['item_name'] = this.getNameCn(item);
        });
        
        this.generateItemKeywords();
        console.log(`已加载 ${this.selectedDate} 的数据`);
        if (this.showPercentile) {
          await this.loadPercentileData();
        }
      } catch (error) {
        console.error('加载本地数据失败:', error);
        // 显示错误信息但不自动取消本地数据模式
        alert(`加载 ${this.selectedDate} 的数据失败，请选择其他日期或检查文件是否存在`);
      } finally {
        this.isLoading = false;
      }
    },
    async onDataSourceChange() {
      if (this.isLoading) return;
      
      this.isLoading = true;
      try {
        if (this.useLocalData) {
          await this.loadAvailableDates();
          // 只有在有可用日期时才尝试加载数据
          if (this.availableDates.length === 0) {
            console.warn('没有找到可用的本地数据文件');
            this.useLocalData = false;
            await this.fetchData();
            return;
          }
          
          // 如果没有选中日期，使用第一个可用日期
          if (!this.selectedDate && this.availableDates.length > 0) {
            this.selectedDate = this.availableDates[0];
          }
          
          if (this.selectedDate) {
            await this.loadSelectedData();
          }
        } else {
          await this.fetchData();
          if (this.showPercentile) {
            await this.loadPercentileData();
          }
        }
      } catch (error) {
        console.error('数据源切换失败:', error);
        this.useLocalData = false;
        await this.fetchData();
      } finally {
        this.isLoading = false;
      }
    },
    async loadPercentileData() {
      let suffix = null;
      if (this.selectedDate && this.dateToFilename[this.selectedDate]) {
        const m = this.dateToFilename[this.selectedDate].match(/items\.simulate_income\.json\.(.+)$/);
        if (m) suffix = m[1];
      } else if (this.availableDates.length > 0) {
        const fn = this.dateToFilename[this.availableDates[0]];
        if (fn) {
          const m = fn.match(/items\.simulate_income\.json\.(.+)$/);
          if (m) suffix = m[1];
        }
      }
      if (!suffix) {
        this.percentileData = {};
        return;
      }
      try {
        const response = await fetch(`/data/aver_price_percentile.json.${suffix}`);
        if (response.ok) {
          this.percentileData = await response.json();
        } else {
          this.percentileData = {};
        }
      } catch (error) {
        console.error('加载分位点数据失败:', error);
        this.percentileData = {};
      }
    },
    async onPercentileToggle() {
      if (this.showPercentile) {
        if (Object.keys(this.percentileData).length === 0) {
          if (this.availableDates.length === 0) {
            await this.loadAvailableDates();
          }
          await this.loadPercentileData();
        }
      } else {
        this.sortByPercentile = false;
      }
    },
    async onSortByPercentileChange() {
      if (this.sortByPercentile && !this.showPercentile) {
        this.showPercentile = true;
        await this.onPercentileToggle();
      }
    },
    getPercentileForItem(item) {
      const slug = item.slug || item.url_name;
      if (!slug || !this.percentileData[slug]) return null;
      const val = this.percentileData[slug][this.selectedPercentilePeriod];
      return val !== undefined ? val : null;
    },
    getPercentileStyle(item) {
      if (!this.showPercentile) return {};
      const val = this.getPercentileForItem(item);
      if (val === null) return {};
      return { backgroundColor: `rgba(255, 0, 0, ${(val * 0.6).toFixed(3)})` };
    },
    formatPercentile(val) {
      if (val === null || val === undefined) return '    ';
      const pct = Math.round(val * 100);
      return String(pct).padStart(3) + '%';
    },
    formatDate(dateStr) {
      return `${dateStr.slice(0, 4)}-${dateStr.slice(4, 6)}-${dateStr.slice(6, 8)}`;
    },
    getIncomeValue(item, type, quantity) {
      const key = `simulate_income.${type}.${quantity}`;
      return (item[key] || 0).toFixed(2);
    },
    isWarframe(name) {
      name = name.replace('Prime', '');
      name = name.replace('prime', '');
      return /[a-zA-Z]/.test(name);
    },
    getNameCn(item) {
      if ('item_name' in item) {
        return item['item_name'];
      } else {
        return item['i18n']['zh-hans']['name'];
      }
    },
    formatName(name) {
      if (this.showInGame) {
        var isSet = name.includes(" 一套");
        var isBp = name.includes(" 蓝图");
        name = name.replace(" 一套", "");
        name = name.replace(" 蓝图", "");
        name = "[" + name + "]";
        if (isSet) {
          name = name + "一套";
        }
        if (isBp) {
          name = name + "蓝图";
        }
      }
      return name;
    },
    handleCopy(event) {
      // 阻止默认的复制行为
      event.preventDefault();

      // 获取用户选中的内容
      const selectedText = window.getSelection().toString();

      // 替换所有换行符和回车符为空格，并合并连续空格
      const textWithoutNewlines = selectedText.replace(/\s+/g, ' ');

      // 将处理后的内容写入剪贴板
      if (event.clipboardData) {
        event.clipboardData.setData('text/plain', textWithoutNewlines);
        event.clipboardData.setData('text/html', ''); // 清除HTML内容
      } else {
        // 兼容旧版浏览器
        const tempTextarea = document.createElement('textarea');
        tempTextarea.value = textWithoutNewlines;
        document.body.appendChild(tempTextarea);
        tempTextarea.select();
        document.execCommand('copy');
        document.body.removeChild(tempTextarea);
      }

      console.log('复制的内容已删除换行符:', textWithoutNewlines);
    },
    parseDateString(dateStr) {
      const match = dateStr.match(/(\d{4})年(\d{1,2})月(\d{1,2})日/);
      if (match) {
        return new Date(match[1], match[2] - 1, match[3]);
      }
      return new Date(0);
    },
    async loadAyaData() {
      try {
        const response = await fetch('/aya.json');
        if (response.ok) {
          const data = await response.json();
          this.ayaPeriods = data.sort((a, b) => 
            this.parseDateString(b.date) - this.parseDateString(a.date)
          );
          if (this.ayaPeriods.length > 0) {
            this.selectedAyaPeriod = this.ayaPeriods[0].date;
            this.updateCurrentAyaRelics();
          }
        }
      } catch (error) {
        console.error('加载 aya.json 失败:', error);
      }
    },
    onAyaPeriodChange() {
      this.updateCurrentAyaRelics();
    },
    updateCurrentAyaRelics() {
      const period = this.ayaPeriods.find(p => p.date === this.selectedAyaPeriod);
      this.currentAyaRelics = period ? period.relics : [];
    }
  },
  async mounted() {
    await this.fetchData();
    // 预加载可用日期列表（但不阻塞界面）
    this.loadAvailableDates();
    // 加载 aya.json
    await this.loadAyaData();
  }
};
</script>

<style scoped>
.main {
  font-family: "Microsoft YaHei", "微软雅黑";
  -moz-osx-font-smoothing: grayscale;
  /* Firefox */
}

.container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 2rem;
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.data-updated {
  padding: 0.4rem 2rem 0;
  max-width: 1400px;
  margin: 0 auto;
  font-size: 0.85rem;
  color: #88888888;
}

.config {
  grid-template-columns: 1fr 1fr 1fr;
  gap: 2rem;
  padding: 2rem 2rem 0rem 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.left-panel,
.middle-panel,
.right-panel {
  display: flex;
  flex-direction: column;
}

.item-grid,
.income-list {
  display: grid;
  gap: 0.1rem;
}

.item-row {
  display: grid;
  grid-template-columns: 3fr 1fr;
  gap: 1rem;
  padding: 0.5rem;
  border-bottom: 1px solid #eee;
}

.item-row-3col {
  grid-template-columns: 3fr 1fr 2.5rem;
}

.percentile-col {
  text-align: right;
  font-family: monospace;
  font-weight: bold;
  white-space: pre;
  color: #900;
}

.name {
  text-align: left;
}

.price,
.income {
  text-align: right;
  font-weight: bold;
  color: #2c3e50;
}

.filter-controls {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
  min-width: 0;
}

.tabs,
.quantity {
  display: flex;
  gap: 0.5rem;
}

button {
  padding: 0.5rem 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  background: white;
}

button.active {
  background: #3498db;
  color: white;
  border-color: #3498db;
}

h2,
h3 {
  color: #2c3e50;
  margin-bottom: 1rem;
}

.group {
  margin-bottom: 2rem;
}

.controls {
  margin-bottom: 1rem;
}

.search-input {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 100%;
  max-width: 300px;
}

.full-width {
  max-width: 100%;
}

label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}


.date-select {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
  min-width: 150px;
  transition: opacity 0.2s;
}

.date-select:disabled,
input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.aya-filter {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.aya-select {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
  width: 250px;
}

.aya-select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>